import localforage from 'localforage'
import { APP_TITLE } from 'constants/customization'

localforage.config({
  name: APP_TITLE,
})

export default localforage
